import { Navigate } from 'react-router';
import type { Service } from '../redux/types';
import type { FC, PropsWithChildren } from 'react';
import { lazy, Suspense } from 'react';
import { getCurrentAccountId, getToSMask } from '../utils/tokenUtils';
import { pathUrl } from '../utils/urlUtils.ts';
import { isToSAccepted } from '../utils/isToSAccepted.ts';
import Loader from '../views/common/loader/Loader.tsx';

type ServiceRouteProps = PropsWithChildren<{
  service: Service;
}>;

const ModalWithTerms = lazy(() => import('../layout/ModalWithTerms'));

const ServiceRoute: FC<ServiceRouteProps> = ({ service, children }) => {
  const currentAccount = getCurrentAccountId();
  const tosMask = getToSMask();

  const isAccepted = isToSAccepted(service.terms?.id, tosMask);

  if (currentAccount === null && service.requireAccount) {
    const { pathname, search } = window.location;
    return <Navigate to={'/select-account?redirect=' + pathUrl(pathname.concat(search))} />;
  }

  if (!service.enabled) {
    return <Navigate to="/404" />;
  }

  if (!isAccepted) {
    return (
      <Suspense fallback={<Loader />}>
        <ModalWithTerms service={service} />
      </Suspense>
    );
  }

  return children;
};

export default ServiceRoute;
